import * as React from 'react';
import { PayoutListView } from './view';
import { useOrganizationStatus } from '../../../queries/useOrganizationStatus';
import { FullscreenLoader } from '../../../components/FullscreenLoader/FullscreenLoader';
import { PageHeading } from '../../../components/PageHeading';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import { useGetDeveloperPayouts } from '../../../types/generated';
import { useEffect } from 'react';
import { InvalidPayoutSettings } from '../PayoutRequest/components/InvalidPayoutSettings';
import { InvalidTaxForm } from '../PayoutRequest/components/InvalidTaxForm';

export const DATE_FORMAT = 'd. MMM yyyy';

export function PayoutList() {
    const {
        hasValidPayoutSettings,
        hasValidTaxForm,
        refetch: refetchStatus,
    } = useOrganizationStatus();
    const { data, loading, refetch } = useGetDeveloperPayouts({
        variables: {
            first: 100,
            after: '',
        },
    });

    useEffect(() => {
        refetch();
        refetchStatus();
    }, [refetch, refetchStatus]);

    if (loading) {
        return <FullscreenLoader />;
    }

    return (
        <>
            <Container maxWidth="md">
                {!hasValidPayoutSettings && (
                    <Box mb={2}>
                        <InvalidPayoutSettings />
                    </Box>
                )}
                {!hasValidTaxForm && (
                    <Box mb={2}>
                        <InvalidTaxForm />
                    </Box>
                )}
                <PageHeading title="Payouts" />
                <Box mt={2}>
                    <PayoutListView data={data} />
                </Box>
            </Container>
        </>
    );
}
